module.exports = __webpack_public_path__ + "static/media/miles-by-the-month-thumbnail.2fe99a9d.png";